module.exports = __webpack_public_path__ + "static/img/org_structure.ea978f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/org_structure.png
// module id = vi4F
// module chunks = 4